import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  getListForm,
  createNewForm,
  deleteForm,
  checkFormToDelete,
} from '../../redux/actions/forms';
import { resetFilter } from '../../../../redux/actions/newFilter';

import FormList from './FormList.page';

const mapStateToProps = state => ({
  listForm: state.allbiller.listForm,
  formFilter: state.allbiller.formFilter,
  loading: state.allbiller.loading,
  filterValue: state.newFilter.filterValue,
  linked: state.allbiller.allowedToDelete,
  billerOfForm: state.allbiller.billerOfForm,
  formControlShow: state.newFilter.formControlShow,
});

const mapDispatchToProps = {
  getListForm,
  createNewForm,
  deleteForm,
  checkFormToDelete,
  resetFilter,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(FormList));
